import React from 'react';
import { Icon } from './Icon';
import { PopoverH } from './TooltipH';

export const DescriptionIco = ({ children, placement = 'top' }) => {
  return <PopoverH
    popupClassName='x_popover_popup'
    // tooltipTheme={{ fontWeightStrong: 100 }}
    title={<div style={{ maxWidth: '20em' }}>{children}</div>}
    placement={placement}
  >
    <div className='_fcc'><Icon className='_o04' style={{ fontSize: '0.8em', cursor: 'pointer' }}>menu_book</Icon></div>
  </PopoverH>
}
